import { Compass, FileText, MessageCircle } from "lucide-react";
import Reveal from "@/components/Reveal";
import { HOW_IT_WORKS } from "@/data/site";

const ICONS = { Compass, FileText, MessageCircle };

export default function HowItWorks() {
    return (
        <section id="como-funciona" className="bg-forest-deep py-24 sm:py-32" data-testid="how-it-works-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal>
                    <p className="text-xs font-semibold uppercase tracking-[0.22em] text-gold">Como Funciona</p>
                    <h2 className="mt-3 max-w-2xl font-serif text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
                        Da vontade à cotação em 3 passos
                    </h2>
                    <p className="mt-4 max-w-2xl text-base leading-relaxed text-stone-300">
                        Nada de formulários infinitos ou espera por e-mail: aqui a conversa acontece onde você já está — no WhatsApp.
                    </p>
                </Reveal>

                <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
                    {HOW_IT_WORKS.map((step, i) => {
                        const Icon = ICONS[step.icon];
                        return (
                            <Reveal key={step.title} delay={i * 0.12}>
                                <div
                                    className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.06] p-8 backdrop-blur-md transition-colors duration-300 hover:border-gold/40"
                                    data-testid={`how-it-works-step-${i + 1}`}
                                >
                                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold">
                                        <Icon className="h-5 w-5" />
                                    </span>
                                    <h3 className="mt-6 font-serif text-xl font-semibold text-white">{step.title}</h3>
                                    <p className="mt-3 flex-1 text-sm leading-relaxed text-stone-300">{step.text}</p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
